import React from 'react'
import ResponsiveImage from 'components/util/ResponsiveImage'
import styles from './_map.css'

import src from 'images/landing/china/map/xsmall.png'
import small from 'images/landing/china/map/small.png'
import medium from 'images/landing/china/map/medium.png'
import large from 'images/landing/china/map/large.png'
import xlarge from 'images/landing/china/map/xlarge.png'

const sources = {
  src,
  small,
  medium,
  large,
  xlarge,
}

function Map () {
  return (
    <div className={styles.map}>
      <ResponsiveImage {...sources} />
    </div>
  )
}
export default Map
